var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundShape(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1923.752,
    height: 685.786,
    viewBox: "0 891.355 1923.752 685.786",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "FOOTER"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "footer_bg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 891.355c141.52 11.7 1437.328 116.26 1923.039 155.95-2.014 73.116 2.082 3 0 113.243s0 139.225 0 139.225H0V891.355Z",
    fill: "#93a5ff",
    fillRule: "evenodd",
    "data-name": "Path 92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1923.752 891.355C1782.232 903.01 486.422 1007.18.712 1046.711c2.014 72.836-2.082 2.989 0 112.81 2.082 109.82 0 417.62 0 417.62h1923.04V891.355Z",
    fill: "#4f46e5",
    fillRule: "evenodd",
    "data-name": "Path 29"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundShape);
export default __webpack_public_path__ + "static/media/BackgroundShape.d6a035bbbcad7f17cb458228fec10132.svg";
export { ForwardRef as ReactComponent };